export function resetFormFilters() {
    const form = $('.posts-filters form');
    const searchInput = form.find("input[type=text]");
    const select = form.find('select');

    form.on('click', '.clear-filters-button', function (e) {
        e.preventDefault();

        select.prop("selectedIndex", 0);
        select.find("option:first-child").prop("selected", true);
        jcf.destroyAll();
        jcf.replaceAll();
        searchInput.val('');
        form.find('input[name="page"]').val(1);
        form.submit();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/resetFormFilters.js